import { render, staticRenderFns } from "./index1-2.vue?vue&type=template&id=53a6c7ce&scoped=true&"
import script from "./index1-2.vue?vue&type=script&lang=js&"
export * from "./index1-2.vue?vue&type=script&lang=js&"
import style0 from "./index1-2.vue?vue&type=style&index=0&id=53a6c7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6c7ce",
  null
  
)

export default component.exports